export default __webpack_public_path__ + "static/media/plantingPlans.c82fdd86.jpg";